@if (filterCriteria && filterCriteria.length !== 0) {
  <div
    class="column__filter__container"
    [@slideInOut]="animationState()"
    (@slideInOut.done)="animationDone($event)"
    >
    @for (filterCriterion of filterCriteriaToToggle; track filterCriterion; let i = $index) {
      <mat-action-list class="column__filter">
        @for (value of filterCriterion?.values; track value) {
          <button
            mat-list-item
            class="column__filter__value"
            [class.column__filter__value--selected]="value.selected"
            (click)="onFilterSelectionChange(value, !value.hasChild, filterCriterion.name)"
            >
            <div class="column__filter__value__button-content">
              <div class="column__filter__value__button-content__label"
                >{{ value.data[filterCriterion.displayProperty] }}
              </div>
              <div class="column__filter__value__button-content__icons">
                @if (value.prediction && value.prediction !== 0) {
                  <campus-icon
                    campusClickPreventDefault
                    campusClickStopPropagation
                    class="column__filter__value__button-content__icons__magnifier"
                    (click)="onFilterSelectionChange(value, true, filterCriterion.name)"
                    [svgIcon]="'magnifier'"
                  ></campus-icon>
                }
                @if (value.hasChild) {
                  <campus-icon
                    campusClickPreventDefault
                    campusClickStopPropagation
                    class="column__filter__value__button-content__icons__arrow"
                    (click)="onFilterSelectionChange(value, false, filterCriterion.name)"
                    [svgIcon]="'column-filter-arrow'"
                  ></campus-icon>
                }
              </div>
            </div>
          </button>
        }
      </mat-action-list>
    }
  </div>
} @else {
  <div class="column__filter--no-criteria">Er is geen inhoudstafel om op te filteren.</div>
}

